import { render, staticRenderFns } from "./ViewMaterial.vue?vue&type=template&id=5474a15d&scoped=true"
import script from "./ViewMaterial.vue?vue&type=script&lang=js"
export * from "./ViewMaterial.vue?vue&type=script&lang=js"
import style0 from "./ViewMaterial.vue?vue&type=style&index=0&id=5474a15d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5474a15d",
  null
  
)

export default component.exports